import styled from "styled-components";
import { SP_BREAKPOINT } from "../../../constants/app";
import { FileUploadResult } from "../../../ducks/file";
import { SearchIcon } from "../../atoms/icons/SearchIcon";
import { Filter } from "../../organisms/Filter";
import { FilterBadge } from "../../organisms/FilterBadge";
import { MainTemplate } from "../../templates/MainTemplate";
import { TableTemplate } from "../../templates/TableTemplate";
import { useFileUploadResult } from "./hook";

export const FileUploadResultPage: React.FC = () => {
  const {
    results,
    total,
    tableHeaders,
    showFilter,
    filter,
    fetchFileUploadResult,
    handleFilter,
    setShowFilter,
    handleBulkDelete,
    handleRowDelete,
    handleRowDownload,
    handleRowSelect,
    handleSelectAll,
    handleRemoveFilterBadge,
    handleMethodsCallback,
  } = useFileUploadResult();

  return (
    <MainTemplate
      title="アップロード結果一覧"
      useFitHeight
      number={`（${total.toLocaleString()}件）`}
      button={{
        text: "検索条件",
        variant: "dark",
        icon: SearchIcon,
        onClick: () => setShowFilter((prev) => !prev),
      }}
    >
      <StyledGrowableContainer>
        <Filter
          isOpen={showFilter}
          onClose={() => setShowFilter(false)}
          onReset={() => {}}
          onFilter={handleFilter}
          onMethods={handleMethodsCallback}
        />
        <FilterBadge
          filter={filter}
          total={total}
          onClick={handleRemoveFilterBadge}
        />
      </StyledGrowableContainer>

      <StyledShrinkableContainer>
        <TableTemplate<FileUploadResult>
          headers={tableHeaders}
          data={results}
          selectable
          defaultSort={{ field: "upload_datetime", order: "desc" }}
          deletable
          downloadable
          enableCSVDownload
          hasPagination
          stickyHeader
          perPage={100}
          total={total}
          fetchDataFunction={fetchFileUploadResult}
          onDownload={handleRowDownload}
          onCSVDownload={handleRowDownload}
          onDelete={handleRowDelete}
          onBulkDelete={handleBulkDelete}
          onSelect={handleRowSelect}
          onSelectAll={handleSelectAll}
        />
      </StyledShrinkableContainer>
    </MainTemplate>
  );
};

const StyledGrowableContainer = styled.div`
  flex-grow: 1;
`;

const StyledShrinkableContainer = styled.div`
  flex-grow: 1;
  flex-shrink: 1;
  min-height: 50%;
  height: 100%;
  @media (max-width: ${SP_BREAKPOINT}) {
    min-height: 90%;
  }
`;
